export class Filter {
    name: string;
    value:any;
    db:string;
    filterApi:string;
    translation:string;
    show:string;
  }
  